
import { computed, defineComponent, ref } from "vue";
import { GameUtils } from "@/utils/GameUtils";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import { useMeta } from "vue-meta";
import GamesFeedbackModal from "../components/gamesFeedbackModal.vue";
import { createToast } from 'mosha-vue-toastify';
import { GameService } from "@/services/GameService";
import vue3starRatings from "vue3-star-ratings";
import router from "@/router";

export default defineComponent({
  name: "viewGamesProfile",
  props: {
      gameId: String
  },
  setup(props) {
      const route = useRoute();
      const store = useStore();
      const label = computed(() => {
          return store.getters["config/configLabel"];
      });
      const metaTitle = ref("MetaXar Games Profile");
      const metaDescription = ref("MetaXar Games Profile Description");
      useMeta({ title: metaTitle.value, description: metaDescription.value });
      const tags = ref([]);
      const languages = ref([]);
      const title = ref("");
      const about = ref("");
      const contentRating = ref("");
      const version = ref("");
      const submittedById = ref("");
      const headerImage = ref("");
      const gameCategory = ref("");
      const lastUpdate = ref("");
      const submissionDate = ref("");
      const userObj = store.getters["auth/user"];
      const jwtToken = store.getters["auth/jwtToken"];
      const ratingKey = ref(0);
      const favouritestext = ref("Added to Favourites");

      const forceRerender = () => {
        ratingKey.value += 1;
        window.location.reload();
      };
      // gallery slider
      // const step = ref(0);
      const isEnabledGalleryPreviousButton = computed(() => {
          return stepCount.value > 0;
      });
      const isEnabledGalleryNextButton = computed(() => {
          return gallery.value.length > ((stepCount.value + 1) * 3);
      });
      const stepCount = ref(0);
      const gallery = ref([]);
      const prevSlide = () => {
          --stepCount.value;
          if (stepCount.value == 0) {
              for (let i = 0; i < gallery.value.length; i++) {
                  if (0 <= i && i <= 2) {
                      gallery.value[i].display = true;
                  }
                  else {
                      gallery.value[i].display = false;
                  }
              }
          }
          else if (stepCount.value == 1) {
              for (let i = 0; i < gallery.value.length; i++) {
                  if (3 <= i && i <= 5) {
                      gallery.value[i].display = true;
                  }
                  else {
                      gallery.value[i].display = false;
                  }
              }
          }
      };
      const nextSlide = () => {
          ++stepCount.value;
          if (stepCount.value == 1) {
              for (let i = 0; i < gallery.value.length; i++) {
                  if (3 <= i && i <= 5) {
                      gallery.value[i].display = true;
                  }
                  else {
                      gallery.value[i].display = false;
                  }
              }
          }
          else if (stepCount.value == 2) {
              for (let i = 0; i < gallery.value.length; i++) {
                  if (6 <= i && i <= 8) {
                      gallery.value[i].display = true;
                  }
                  else {
                      gallery.value[i].display = false;
                  }
              }
          }
      };
      const assetURL = computed(() => {
          return store.getters["config/assetUrl"];
      });

      const starlist = ref([]);
        const avgRating = computed(() => {
          var totalRatings = starlist.value.length;
          var sumRating = starlist.value.reduce((pv, cv) => pv + cv, 0);
          var avgRating = (sumRating/totalRatings);
            return avgRating;
        });


        const fetchRatings = async () => {
          starlist.value = [];
          const ratingList = await GameUtils.fetchRatingList(props.gameId);
          const ratings = ratingList.filter((rating, index) => {
          starlist.value.push(rating.rating);
          });
        };


        const totalRatings = computed(()=> {
          var totalRatings = starlist.value.length;
          return totalRatings;
        });

      const favouriteList = ref([]);
      const favourited = ref();

    const favouriteGame = async () => {
    let favouriteGame = await GameUtils.favouriteGame(props.gameId)
    checkFavourite()
    createToast(
      {
        title: 'Game Favourited',
      },
      {
        position: "bottom-right",
        type: "success",
        timeout: 5000
      }
    );
  }

    const unfavouriteGame = async () => {
    let favouriteGame = await GameUtils.unfavouriteGame(props.gameId)
    checkFavourite()
    createToast(
      {
        title: 'Game Unfavourited',
      },
      {
        position: "bottom-right",
        type: "success",
        timeout: 5000
      }
    );
  }

  const checkFavourite = async () => {
    const favouriteGame = await GameUtils.fetchFavouriteGame();
    favouriteList.value = [];
    const favouriteGameId = favouriteGame.filter((favouriteGame, index) => {
      favouriteList.value.push(favouriteGame.game.gameId);
    });
    if (favouriteList.value.indexOf(props.gameId) !== -1){
      favourited.value = true
      }else{
      favourited.value = false
    }
  }





      (async () => {
          const gameDetails = await GameUtils.fetchPublishedGame(props.gameId);
          // console.log(gameDetails)
          if(!gameDetails) {
            router.push('/invalid-game-id');
          }
          fetchRatings();
          if (store.getters['auth/authenticated']) {
            checkFavourite();
          }
          title.value = gameDetails.viewModel.game.title;
          submittedById.value = gameDetails.viewModel.game.publishedBy;
          gameCategory.value = gameDetails.viewModel.game.category;
          about.value = gameDetails.viewModel.details.about.about;
          tags.value = gameDetails.viewModel.game.tags;
          contentRating.value = gameDetails.viewModel.game.contentRating;
          version.value = gameDetails.viewModel.game.version;
          languages.value = gameDetails.viewModel.game.languages;
          if (gameDetails.viewModel.details.gallery.headerImage) {
              headerImage.value = assetURL.value + `blob/games/${props.gameId}/gallery/${gameDetails.viewModel.details.gallery.headerImage}`;
          }
          else {
              headerImage.value = "none";
          }
          if (gameDetails.viewModel.details.gallery.galleryImages.length > 0) {
              gameDetails.viewModel.details.gallery.galleryImages.forEach((image, index) => {
                  gallery.value.push({
                      id: index + 1,
                      url: assetURL.value + `blob/games/${props.gameId}/gallery/${image}`,
                      itemCount: index + 1,
                      display: (index > 2) ? false : true,
                  });
              });
          }
      })();
      const displayFeedbackModal = ref(false);


      return {
          forceRerender,
          fetchRatings,
          favouriteGame,
          unfavouriteGame,
          ratingKey,
          store,
          displayFeedbackModal,
          lastUpdate,
          submissionDate,
          submittedById,
          gameCategory,
          tags,
          languages,
          title,
          about,
          contentRating,
          version,
          headerImage,
          stepCount,
          gallery,
          prevSlide,
          nextSlide,
          isEnabledGalleryPreviousButton,
          isEnabledGalleryNextButton,
          // isFeedbackDone,
          label,
          userObj,
          avgRating,
          totalRatings,
          favourited,
          favouritestext,
      };
  },
  components: { GamesFeedbackModal, vue3starRatings }
});
